import { render, staticRenderFns } from "./ChapterRightSidebar.vue?vue&type=template&id=27b0e6d0&scoped=true&"
import script from "./ChapterRightSidebar.vue?vue&type=script&lang=js&"
export * from "./ChapterRightSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ChapterRightSidebar.vue?vue&type=style&index=0&id=27b0e6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b0e6d0",
  null
  
)

export default component.exports